/** MIC (Management Insight & Control) — read-only CRM with contact masking. */

export const ROLE_MIC = "MIC";
export const HIDDEN_CONTACT = "Hidden";

export function isMicRole(role = localStorage.getItem("userRole")) {
  return role === ROLE_MIC;
}

/** MIC cannot create, edit, delete, assign, or communicate. */
export function canMutateCrm(role = localStorage.getItem("userRole")) {
  return !isMicRole(role);
}

/** Whether contact identity (phone/email) may be shown in the UI. */
export function canShowContact(role = localStorage.getItem("userRole")) {
  return !isMicRole(role);
}

/**
 * CSV / workbook exports are allowed for MIC (contacts masked server-side and in UI).
 * Proposal PDFs stay blocked — use canDownloadProposalPdf.
 */
export function canExportData() {
  return true;
}

/** Opportunity proposal PDFs embed raw contacts — never for MIC. */
export function canDownloadProposalPdf(role = localStorage.getItem("userRole")) {
  return !isMicRole(role);
}

/** Roles that may use list CSV export buttons (admin-style dumps). */
export function canUseListCsvExport(role = localStorage.getItem("userRole")) {
  return role === "Super Admin" || role === "Manager" || role === ROLE_MIC;
}

export function displayContact(value, role = localStorage.getItem("userRole")) {
  if (isMicRole(role)) return HIDDEN_CONTACT;
  if (value == null || value === "") return "—";
  return value;
}

/** Paths MIC may open in the sidebar / router. */
export const MIC_ALLOWED_PATHS = [
  "/profile",
  "/dashboard",
  "/target-achievement",
  "/leads",
  "/clients",
  "/properties",
  "/newopp",
  "/pipeline",
  "/tasks",
  "/rrport",
  "/report-daily",
];
